import { ActionType } from '../../core/redux/actionType';
import { ApiReducer, makeApiAction, makeApiReducer, makeRsaaTypes } from '../../core/api/rsaa';
import { addError, addLoading, noLoadingNoError, getLoading } from '../../core/api/module';
import * as R from 'ramda';
import { Endpoints } from '../../core/api/endpoints';
import { UserInfo } from '../authState';


const KEY_ACTION = ActionType.YmcaSsoRequest;
const ACTIONS = [
  ActionType.YmcaSsoRequest,
  ActionType.YmcaSsoResponse,
  ActionType.YmcaSsoError,
];


type Payload = UserInfo;


type Meta = {
  email: string;
};


/**
 * Dispatch this action to authenticate to the portal through Ymca SSO
 * @param ticket - comes from ymca
 * @param projectId - project display id
 * @param returnUrl - alternate way to get project display id. 
 */
export const ymcaSsoAction = (ticket?: string, projectId?: string, returnUrl?: string) => makeApiAction<Payload, Meta>({
  method: 'POST',
  endpoint: Endpoints.YmcaLogin,
  headers: { 'content-type': 'application/json' },
  body: JSON.stringify({ ticket: ticket, projectId: projectId, returnUrl: returnUrl }),
  types: makeRsaaTypes<Payload, Meta>(ACTIONS),
  bailout: state => !!getLoading(state, KEY_ACTION),
});

const reducer: ApiReducer<Payload, Meta> = (state, action, errorMsg, isLoading, payload) => {
  if (isLoading) {
    return addLoading(state, KEY_ACTION);
  }

  if (errorMsg) {
    return addError(state, KEY_ACTION, errorMsg);
  }

  const successState = noLoadingNoError(state, KEY_ACTION);

  return R.assocPath(['auth', 'currentUser'], payload, successState);
};

export const ymcaSsoReducer = makeApiReducer<Payload, Meta>(ACTIONS, KEY_ACTION, reducer);